import { TextField } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors, fonts, paddings, borders, margins } from '~/layout';

export const BoxValidation = lib.styled.div`
  display: flex;
  flex: 1;
  max-height: 15px;
  align-items: center;
  justify-content: ${props => (props.error ? 'space-between' : 'flex-end')};

  .error {
    font-size: 9px;
    color: ${colors.red02};
  }
  .size {
    text-align: end;
    font-size: 9px;
    color: ${colors.darkGray03};
  }
`;

export const Container = lib.styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${paddings.alternative}px;
  margin-right: ${paddings.alternative}px;
  border-radius: ${borders.radius * 2}px;
  background-color: ${colors.white02};
  padding: ${paddings.default / 2}px;

  .cancelBtn {
    text-align: center;
    font-size: 10px;
    margin-top: 10px;
    cursor: pointer;
  }
`;

export const TagsCardHeader = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  width: 100%;

  .close-icon {
    font-size: ${fonts.default}px;
    color: ${colors.black};
    cursor: pointer;
  }
`;

export const ActionsContainer = lib.styled.div`
  display: flex;
  max-width: 45px;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  margin-right: 5px;

  .assigned-tags {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: -25px;
    margin-right: 15px;

    svg {
      display: inline-block !important;
    }
  }

  svg:last-child {
    margin-left: 5px;
  }

  .MuiSvgIcon-root {
    width: 18px !important;
  }

  div {
    max-height: 20px;
  }
`;

export const Title = lib.styled.span`
  font-size: ${fonts.default}px;
  color: ${colors.black}!important;
`;

export const RowTag = lib.styled.div`
  display: flex;
  flex: 1;
  cursor: pointer;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-height: 45px;
  max-height: 45px;
  background-color: ${props => props.color};
  margin-top: ${margins.labelTop}px;
  border-radius: ${borders.radius}px;
  padding-left: 5px;
  padding-right: 5px;

  div {
    display: flex;
    flex: 1;
  }

  .internal-content {
    padding: 12px 0px 12px 10px;
    margin-right: 10px;
  }

  .input-edit {
    background-color: transparent!important;
    margin-top: 12px!important;
    margin-bottom: 0px!important;

    div {
      width: 100%;
      max-height: 35px;
      height: 35px;
      padding-top: 0px;
      padding-bottom: 0px;

      fieldset {
        max-height: 35px;
      }
      input {
        padding-top: 0px;
        padding-bottom: 0px;
        color: ${colors.white};
      }
    }
  }

  .icon-edit {
    font-size: ${fonts.title}px;
    color: ${colors.white};
    cursor: pointer;
  }

  span {
    color: ${colors.white};
    font-size: ${fonts.default}px;
  }
`;

export const ListTags = lib.styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-height: 150px;
  padding-right: 8px;
  box-sizing: border-box;
  -ms-overflow-style: none!important;
  overflow-y: auto;
  overflow-x: hidden;
  outline: none!important;
  &::-webkit-scrollbar { width: 0!important }

  .no-tags {
    text-align: center;
    padding: 20px;
    font-size: 14px;
    color: ${colors.lightGray02};
  }

  .MuiOutlinedInput-inputMarginDense {
    padding-top: unset;
    padding-bottom: unset;
  }

  .MuiOutlinedInput-input {
    padding: 5px;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: transparent; 
    border-width: 0px;
  }
`;

export const InputField = lib.styled(TextField)`
  background-color: ${colors.white};
  border: 1px solid ${colors.white02};
  width: 100%;
  border-radius: ${borders.radius}px;
  margin-top: 15px !important;
  margin-bottom: 15px !important;
  .MuiInputBase-input {
    font-size: ${fonts.menu}px; !important;
  }
`;

export const InputTagName = lib.styled(TextField)`
  background-color: ${props => props.bgcolor || 'transparent'};
  border: ${props => (props.color ? '0px' : '1px')} solid ${colors.white02};
  max-height: 45px;
  min-height: 45px;
  width: 100%;
  border-radius: ${borders.radius}px;
  outline: none;

  &:focus {
    fieldset {
      border-color: ${props =>
        props.bgcolor ? 'rgba(0, 0, 0, 0.23)' : colors.darkBlue}!important;
    }
  }

  input {
    padding-bottom: 11px!important;
    color: ${props => (props.bgcolor ? colors.white : colors.black)};
  }
`;

export const BoxNewTag = lib.styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${margins.inputTop}px;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  gap: 3px;
`;

export const Item = lib.styled.button`
  flex: 1 1 34px;
  min-width: 0;
  max-width: 34px;
  max-height: 20px;
  min-height: 20px;
  border-radius: 4px;
  background-color: ${props => props.color};
  text-align: center;
  border: 0!important;
  margin-bottom: 5px;
  outline: none;

  .icon-tags {
    font-size: 14px;
    color: ${colors.white};
  }
`;

export const ButtonNewTag = lib.styled.button`
  background-color: ${colors.lightGray07};
  height: 45px;
  min-height: 45px;
  max-height: 45px;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  border: 0px!important;
  outline: none;
  margin-top: ${margins.inputTop}px;
  border-radius: ${borders.radius}px;
  cursor: pointer;

  span {
    color: ${colors.black};
    font-size: ${fonts.default}px;
    font-weight: 600;
  }
`;
